import InfoIcon from 'components/primitives/icons/InfoIcon/InfoIcon';

export default function SnapshotInfoIcon(props: {}) {
  const content = <div>Snapshotting saves a copy of a table every day at 3:05am PT.</div>;
  const popoverProps = { style: { maxWidth: '550px' } };
  return <InfoIcon content={content} popoverProps={popoverProps} placement="left" />;
}
